<template>
  <div class="eventendContainer" id="eventendContainer">
    <el-card>
      <div class="navBar">
        <el-row :gutter="40">
          <el-col :span="10">
            <div class="nav">
              <span
                :class="['navItem', activeIndex === index ? 'active' : '']"
                v-for="(item, index) in navBar"
                :key="item"
                @click="handleChange(index)"
                >{{ item }}</span
              >
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search">
              <el-input
                :placeholder="placeholder"
                v-model="inputVal"
                clearable
                @clear="clear"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="selectTime"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-col>
        </el-row>
      </div>
      <div class="firstMain" v-if="activeIndex === 0">
        <el-row :gutter="14">
          <el-col :span="8" v-for="(item, index) in data" :key="index">
            <div class="item h325">
              <div class="header">
                <div>
                  <i></i>
                  <span class="number">{{ item.code }}</span>
                  <span
                    :class="[
                      'status',
                      item.type === 2 ? 'state1' : 'state state3',
                    ]"
                    >{{ item.type === 2 ? "紧急" : "日常" }}</span
                  >
                </div>
                <span
                  :class="['result', item.status === 0 ? 'state' : 'state1']"
                  >{{ item.status === 0 ? "待接收" : "已接收" }}</span
                >
              </div>
              <div class="main">
                <div class="main_item">
                  <span class="attr w80">工地名称：</span>
                  <span class="desc">{{ item.construction }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">工地地址：</span>
                  <span class="desc">{{ item.address }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">发布人：</span>
                  <span class="desc">{{ item.username }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">发布时间：</span>
                  <span class="desc">{{ item.releasetime }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">接收调度：</span>
                  <span class="desc">{{ item.confirmtime }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">督查时间：</span>
                  <span class="desc">{{ item.supervisetime }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">督查问题：</span>
                  <span class="problem">{{ item.reply }}</span>
                </div>
              </div>
              <!-- <div class="bottom" ref="bottom"> -->
              <!-- <div class="bottom_item" @click="toShowDetails(item)">
                  <img src="../assets/share.png" alt />
                  <span>分享</span>
                </div>
                <div class="bottom_item" v-print="'#printData'+index">
                  <img src="../assets/print.png" alt />
                  <span>打印</span>
                </div>
                <div class="bottom_item" @click="ExportSavePdf(htmlTitle,'printData'+index)">
                  <img src="../assets/download.png" alt />
                  <span>下载</span>
              </div>-->
              <!-- </div> -->
              <EventEndBottom @click="toShowDetails(item, $event)" />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="sencondMain" v-else-if="activeIndex === 1">
        <el-row :gutter="14">
          <el-col :span="8" v-for="(item, index) in data" :key="index">
            <div class="item">
              <div class="header">
                <div>
                  <i></i>
                  <span class="number">{{ item.code }}</span>
                </div>
                <span
                  :class="['result', item.status === '0' ? 'state' : 'state1']"
                  >{{ item.status === "0" ? "未归档" : "已归档" }}</span
                >
              </div>
              <div class="main">
                <div class="main_item">
                  <span class="attr w60">类型：</span>
                  <span class="desc">{{ item.p0 }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w60">工地：</span>
                  <span class="desc">{{ item.address }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w70">督查人：</span>
                  <span class="desc">{{ item.uname }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w60">描述：</span>
                  <span class="desc">{{ item.p2 }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w70">图片：</span>
                  <div class="pic">
                    <el-image
                      style="
                        width: 70px;
                        height: 52px;
                        vertical-align: text-top;
                        margin-right: 10px;
                        margin-bottom: 4px;
                      "
                      :src="subItem"
                      v-for="(subItem, subIndex) in item.p3"
                      :key="subIndex"
                    ></el-image>
                  </div>
                </div>
              </div>
              <EventEndBottom
                :time="item.uptime"
                @click="toShowDetails(item, $event)"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="thirdMain" v-else-if="activeIndex === 2">
        <el-row :gutter="14">
          <el-col :span="8" v-for="(item, index) in data" :key="index">
            <div class="item">
              <div class="header">
                <div>
                  <i></i>
                  <span class="number">{{ item.eventcode }}</span>
                </div>
                <span
                  :class="['result', item.status === 1 ? 'state' : 'state1']"
                  >{{ item.status === 1 ? "已完成" : "未完成" }}</span
                >
              </div>
              <div class="main">
                <!-- <div class="main_header">{{item.inspector}}</div> -->
                <div class="main_item">
                  <span class="attr">{{ item.object }}：</span>
                  <span class="desc">{{ item.reason }}</span>
                </div>
              </div>
              <EventEndBottom
                :time="item.releasetime"
                @click="toShowDetails(item, $event)"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="fourthMain" v-else-if="activeIndex === 3">
        <el-row :gutter="14">
          <el-col :span="8" v-for="(item, index) in data" :key="index">
            <div class="item h193">
              <div class="header">
                <div>
                  <i></i>
                  <span class="number">{{ item.eventcode }}</span>
                </div>
                <span
                  :class="['result', item.status === 0 ? 'state' : 'state1']"
                  >{{ item.status === 0 ? "未约谈" : "已约谈" }}</span
                >
              </div>
              <div class="main">
                <div class="main_item">
                  <span class="attr w80">约谈对象：</span>
                  <span class="desc">{{ item.object }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">约谈原由：</span>
                  <span class="desc">{{ item.reason }}</span>
                </div>
              </div>
              <EventEndBottom
                :time="item.releasetime"
                @click="toShowDetails(item, $event)"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="fifthMain" v-else-if="activeIndex === 4">
        <el-row :gutter="14">
          <el-col :span="8" v-for="(item, index) in data" :key="index">
            <div class="item h193">
              <div class="header">
                <div>
                  <i></i>
                  <span class="number">{{ item.eventcode }}</span>
                </div>
                <span
                  :class="['result', item.status === 0 ? 'state' : 'state1']"
                  >{{ item.status === 0 ? "待追责" : "已追责" }}</span
                >
              </div>
              <div class="main">
                <div class="main_item">
                  <span class="attr w80">追责对象：</span>
                  <span class="desc">{{ item.object }}</span>
                </div>
                <div class="main_item">
                  <span class="attr w80">追责原由：</span>
                  <span class="desc">{{ item.reason }}</span>
                </div>
              </div>
              <EventEndBottom
                :time="item.releasetime"
                @click="toShowDetails(item, $event)"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="promptInfo" v-if="!isShow">暂无数据</div>
      <!-- 批量下载按钮 -->
      <el-button size="small" v-if="isShow" @click="toDownload" class="btn"
        >批量下载</el-button
      >
      <!-- 分页器 -->
      <Pagination
        v-show="isShow"
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        :pageSizes="[6, 9, 12, 15]"
        @pagination="pagination"
      />
    </el-card>
    <!-- 分享详情对话框 -->
    <DetailDialog
      title="事件详情"
      :superviseArrangeList="superviseArrangeList"
      :detaildata="detaildata"
      :eventFlowList="eventFlowList"
      :timelineList="timelineList"
      :detailList="detailObj"
      :detail="detail"
      :questionList="questionList"
      :imglist="imglist"
      :activeName="activeIndex"
      :showItem="clickItem"
      :htmlTitle="htmlTitle"
      @close="closeDetailDialog"
      v-if="isShowDetailDialog"
    />
    <!-- 下面的都是走批量下载 -->
    <!-- 批量下载对话框 -->
    <DownloadDialog
      :activeIndex="activeIndex"
      :loading.sync="loading"
      :isBatchDowlnload.sync="isBatchDowlnload"
      @batchDownload="batchDownload"
      title="批量下载"
      v-if="isShowDownloadDialog"
      @close="closeDownloadDialog"
    />
    <!-- import test -->
    <SuperviseArrangeDetail
      style="position: fixed; width: 40%; top: 9999px; left: 10000px"
      :detailList="superviseArrangeList"
      :detaildata="detaildata"
      @load="load"
      v-if="activeIndex === 0"
    />
    <EventFlowDetail
      style="position: fixed; width: 40%; top: 9999px; left: 10000px"
      :detailList="eventFlowList"
      :imgList="imglist"
      :timelineList="timelineList"
      v-if="activeIndex === 1"
      @load="load"
    />
    <ExpertInDetail
      style="position: fixed; width: 40%; top: 9999px; left: 10000px"
      :detailObj="detailObj"
      @load="load"
      v-if="activeIndex === 2"
    />
    <QueryTalkDetail
      style="position: fixed; width: 40%; top: 9999px; left: 10000px"
      :detailObj="detailObj"
      :questionList="questionList"
      :imgList="imglist"
      @load="load"
      v-if="activeIndex === 3"
    />
    <ResponseDetail
      style="position: fixed; width: 40%; top: 9999px; left: 10000px"
      :detailObj="detail"
      :questionList="questionList"
      :imgList="imglist"
      v-if="activeIndex === 4"
      @load="load"
    />
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination";
import DetailDialog from "@/components/EventEnd/DetailDialog";
import DownloadDialog from "@/components/EventEnd/DownloadDialog";
import EventEndBottom from "@/components/EventEnd/EventEndBottom";
import SuperviseArrangeDetail from "@/components/Details/SuperviseArrangeDetail";
import EventFlowDetail from "@/components/Details/EventFlowDetail";
import ExpertInDetail from "@/components/Details/ExpertInDetail";
import QueryTalkDetail from "@/components/Details/QueryTalkDetail";
import ResponseDetail from "@/components/Details/ResponseDetail";
import { getServerData } from "../utils/fetchData";
import { APIMAP } from "../constants/apiConstants";
// import { getFormatDate } from "../utils/util";
import { mapState } from "vuex";

export default {
  components: {
    Pagination,
    DetailDialog,
    EventEndBottom,
    ExpertInDetail,
    DownloadDialog,
    SuperviseArrangeDetail,
    EventFlowDetail,
    QueryTalkDetail,
    ResponseDetail,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      showChat: (state) => state.Chat.showChat,
      chatMessage: (state) => state.Chat.chatMessage,
    }),
    isShow() {
      if (this.data.length > 0) return true;
      return false;
    },
    placeholder() {
      if (this.activeIndex === 0 || this.activeIndex === 1)
        return "请输入工地名称";
      else return "请输入对象名称";
    },
  },
  data() {
    return {
      loading: false,
      resolve: null, // resolve函数
      nowTitle: "", // 当前下载的文件名
      navBar: ["督查调令", "督查事件", "介入事件", "约谈事件", "追责事件"],
      activeIndex: 0, // 被激活的索引
      inputVal: "", // 搜索地点
      time: [], // 日期
      data: [],
      page: 1,
      size: 6,
      total: 0,
      startTime: "",
      endTime: "",
      isShowDetailDialog: false,
      isShowDownloadDialog: false,
      gid: null,
      detailObj: {},
      clickItem: "", // 点击的哪一项
      detail: {},
      questionList: [],
      imglist: [],
      superviseArrangeList: [],
      detaildata: {},
      eventFlowList: [],
      timelineList: [],
      stateMap: {
        "-2": "被驳回",
        "-1": "已删除",
        "-3": "退回重做",
        0: "待审核",
        1: "待签批",
        2: "待处理",
        3: "待处罚",
        4: "待扣分",
        5: "待整改",
        6: "申诉待处理",
        7: "待复查",
        8: "待归档",
        9: "已完结",
        10: "去整改",
        11: "住建审核",
      },
      htmlTitle: "",
      isBatchDowlnload: false,
    };
  },
  created() {
    this.getDispatchList();
  },
  methods: {
    load() {
      console.log("触发了嘛？？？？？？？？");
      // 点击批量下载时才触发
      if (!this.isBatchDowlnload) return;
      console.log("进来了");
      this.ExportSavePdf(
        this.nowTitle || "详情",
        "nowPrintDetail",
        this.resolve
      );
      if (this.resolve) {
        this.resolve = null;
      }
    },
    handleChange(i) {
      this.activeIndex = i;
      this.startTime = "";
      this.endTime = "";
      this.time = [];
      this.inputVal = "";
      this.data = [];
      this.page = 1;
      this.htmlTitle = "";
      this.detailObj = {};
      this.decide(i);
    },
    // 选择时间
    selectTime(val) {
      console.log(val);
      if (val !== null) {
        this.startTime = val[0] + " " + "00:00:00";
        this.endTime = val[1] + " " + "23:59:59";
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      const { activeIndex } = this;
      this.decide(activeIndex);
    },
    // 分页
    pagination() {
      const { activeIndex } = this;
      this.decide(activeIndex);
    },
    // 获取督查调令数据
    async getDispatchList() {
      try {
        let params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.uid = this.userInfo.gid;
        params.starttime = this.startTime;
        params.endtime = this.endTime;
        params.status = 1;
        if (this.inputVal.trim() !== "") {
          params = {
            ...params,
            construction: this.inputVal.trim(),
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.DSIPATCH, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => {
          if (item.reply === 0) {
            item.reply = "待确认";
          } else if (item.reply === 1) {
            item.reply = "没有问题";
          } else {
            item.reply = "存在问题";
          }
        });
        this.data = res.rows;
        this.total = res.total;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取督查事件数据
    async getEventList() {
      try {
        let params = {};
        params.page = this.page;
        params.size = this.size;
        params.eid = this.userInfo.eid;
        params.uid = this.userInfo.gid;
        params.startTime = this.startTime;
        params.endTime = this.endTime;
        params.status = 9;
        if (this.inputVal.trim() !== "") {
          params = {
            ...params,
            construction: this.inputVal.trim(),
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.EVENT, params);
        res.rows.forEach((item) => {
          if (item.p3 !== null) {
            item.p3 = item.p3.split("|");
          }
        });
        console.log("返回数据", res);
        this.data = res.rows;
        this.total = res.total;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取介入列表数据
    async getExpertintervention() {
      try {
        let params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.status = 1;
        params.starttime = this.startTime;
        params.endtime = this.endTime;
        if (this.inputVal.trim() !== "") {
          params = {
            ...params,
            object: this.inputVal.trim(),
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.EXPERTINTERVENTION, params);
        console.log("返回数据", res);
        this.data = res.rows;
        this.total = res.total;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取约谈事件列表
    async getInterviewList() {
      try {
        let params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.type = 1;
        params.startTime = this.startTime;
        params.endtime = this.endTime;
        params.status = 1;
        if (this.inputVal.trim() !== "") {
          params = {
            ...params,
            object: this.inputVal.trim(),
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.INTERVIEW, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => {
          item.address = item.object;
        });
        this.data = res.rows;
        this.total = res.total;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取追责事件列表
    async getAccountability() {
      try {
        let params = {};
        params.page = this.page;
        params.size = this.size;
        params.pid = this.userInfo.platformid;
        params.type = 2;
        params.startTime = this.startTime;
        params.endtime = this.endTime;
        params.status = 1;
        if (this.inputVal.trim() !== "") {
          params = {
            ...params,
            object: this.inputVal.trim(),
          };
        }
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.INTERVIEW, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => {
          item.address = item.object;
        });
        this.data = res.rows;
        this.total = res.total;
      } catch (error) {
        console.log(error);
      }
    },
    // 搜索框
    async search() {
      if (this.inputVal.trim() === "") return;
      this.decide(this.activeIndex);
    },
    // 清空搜索框
    clear() {
      this.decide(this.activeIndex);
    },
    // 判断
    decide(i) {
      switch (i) {
        case 0:
          this.getDispatchList();
          break;
        case 1:
          this.getEventList();
          break;
        case 2:
          this.getExpertintervention();
          break;
        case 3:
          this.getInterviewList();
          break;
        case 4:
          this.getAccountability();
          break;
        default:
          return;
      }
    },
    // 处理督查调令详情数据
    superviseArrangeDetail(detailList, isBatch) {
      return new Promise((resolve) => {
        console.log("进来了嘛？");
        const res = detailList;
        switch (res.reply) {
          case 0:
            res.reply = "待确认";
            break;
          case 1:
            res.reply = "没有问题";
            break;
          case 2:
            res.reply = "存在问题";
            break;
          default:
            break;
        }
        const superviseArrangeList = [];
        superviseArrangeList.push(
          {
            name: "监理",
            value: res.consupervision,
          },
          {
            name: "甲方",
            value: res.conbuilding,
          },
          {
            name: "乙方",
            value: res.conconstruction,
          },
          {
            name: "事件类型",
            value: res.type === 1 ? "日常调度" : "紧急调度",
          },
          {
            name: "事件编号",
            value: res.code,
          },
          {
            name: "工地名称",
            value: res.construction,
          },
          {
            name: "工地地址",
            value: res.conadress,
          },
          {
            name: "信用等级",
            value: res.conlevel,
          },
          {
            name: "历史问题",
            value: [
              {
                name: "整改",
                value: res.rectify,
              },
              {
                name: "扣分",
                value: res.deduction,
              },
              {
                name: "处罚",
                value: res.punishment,
              },
            ],
          },
          {
            name: "发布人",
            value: res.username,
          },
          {
            name: "发布时间",
            value: res.releasetime,
          },
          {
            name: "接收调度",
            value: res.confirmtime,
          },
          {
            name: "督查时间",
            value: res.supervisetime,
          },
          {
            name: "督察小组",
            value: res.inspection,
          },
          {
            name: "督查问题",
            value: res.reply,
          }
        );
        this.superviseArrangeList = superviseArrangeList;
        this.detaildata = detailList;
        console.log(this.superviseArrangeList, this.detaildata, detailList);
        this.htmlTitle = res.code + res.address;

        if (isBatch) {
          this.resolve = resolve;
          this.$nextTick(() => {
            this.load();
          });
        } else {
          console.log("到这里了嘛？", this.detaildata);
          this.isShowDetailDialog = true;
          resolve();
        }
      });
    },
    // 处理督查事件详情数据
    eventFlowDetail(detailList, isBatch) {
      return new Promise(async (resolve) => {
        const res = detailList;
        const eventFlowList = [];
        eventFlowList.push(
          {
            name: "上传人员",
            type: "uname",
            value: res.uname,
          },
          {
            name: "上传时间",
            type: "uptime",
            value: res.uptime,
          },
          {
            name: "当前状态",
            type: "status",
            value: this.stateMap[String(res.status)],
          },
          {
            name: "下级流转部门",
            type: "receivedept",
            value: res.receivedept,
          },
          {
            name: "问题类型",
            type: "",
            value: JSON.parse(res.putype),
          },
          {
            name: "问题描述",
            type: "",
            value: "",
          }
        );
        this.eventFlowList = eventFlowList;
        // 先resolve，在保存图片（图片加载完会触发load事件）
        this.resolve = resolve;
        await this.getEventFlowDetail(detailList.gid, isBatch);
        this.imglist = res.p3;
      });
    },
    // 获取督查事件详情数据
    getEventFlowDetail(gid, isBatch) {
      return new Promise(async (resolve, reject) => {
        try {
          const params = {};
          params.gid = gid;
          params.eid = this.userInfo.eid;
          console.log("请求参数", params);
          const res = await getServerData(APIMAP.EVENT + `/${gid}`, params);
          console.log("返回数据", res);
          this.htmlTitle = res.master.code + res.master.address;
          const { slave } = res;
          if (slave && slave.length) {
            this.timelineList = slave;
          }
          if (isBatch) {
            resolve();
          } else {
            this.isShowDetailDialog = true;
            resolve();
          }
        } catch (error) {
          reject(error);
          console.log(error);
        }
      });
    },
    // 获取介入列表详情数据
    getExpertInDetail(gid, isBatch) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getServerData(
            APIMAP.EXPERTINTERVENTION + `/${gid}`,
            {
              gid,
            }
          );
          console.log("返回数据", res);
          if (res.imgurl) {
            res.imgurl = res.imgurl.split("|");
          }
          this.detailObj = res;
          this.detail = res;

          if (isBatch) {
            console.log("批量");
            // this.resolve = resolve;
            resolve();
            this.$nextTick(() => {
              this.load();
            });
          } else {
            // 单个
            this.$nextTick(() => {
              this.isShowDetailDialog = true;
              resolve();
            });
          }
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
    },
    // 获取约谈事件详情数据
    getQueryTalkDetail(gid, isBatch) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getServerData(APIMAP.INTERVIEW + `/${gid}`, {
            gid,
          });
          console.log("返回数据", res);
          this.detailObj = res;
          this.htmlTitle = res.eventcode + res.object;
          this.fmtdetail(res, resolve, isBatch);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
    },
    // 获取追责事件详情数据
    getResponseDetail(gid, isBatch) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await getServerData(APIMAP.INTERVIEW + "/" + gid, {
            gid,
          });
          console.log("追责详情", res);
          this.detailObj = res;
          this.htmlTitle = res.eventcode + res.object;
          this.fmtdetail(res, resolve, isBatch);
        } catch (error) {
          console.log(error);
          reject(error);
        }
      });
    },
    fmtdetail(data, resolve, isBatch) {
      var qlist = data.reasondetail.split(";");
      this.detail = data;
      this.questionList = qlist;
      if (data.status == 1) {
        this.imglist = data.imgurl && data.imgurl.split("|");
        console.log(
          this.imglist,
          this.imglist === undefined,
          this.imglist === undefined ? "没图片" : "有图片"
        );
        // 代表没有图片
        if (this.imglist === undefined) {
          // 是否是批量下载
          if (isBatch) {
            console.log("进来了嘛？");
            this.resolve = resolve;
            this.$nextTick(() => {
              this.load();
            });
          } else {
            console.log("你去哪里了？");
            this.isShowDetailDialog = true;
            resolve();
          }
          return;
        }
      }
      // 是否是批量
      if (isBatch) {
        // 批量下载走这个
        this.resolve = resolve;
      } else {
        // 单个详情走以前的
        this.isShowDetailDialog = true;
        resolve();
      }
    },
    toShowDetails(item, val, isBatch = false) {
      console.log(item);
      return new Promise(async (resolve, reject) => {
        try {
          this.clickItem = val;
          const { activeIndex } = this;
          if (activeIndex === 0) {
            await this.superviseArrangeDetail(item, isBatch);
          } else if (activeIndex === 1) {
            await this.eventFlowDetail(item, isBatch);
          } else if (activeIndex === 2) {
            await this.getExpertInDetail(item.gid, isBatch);
          } else if (activeIndex === 3) {
            await this.getQueryTalkDetail(item.gid, isBatch);
          } else if (activeIndex === 4) {
            await this.getResponseDetail(item.gid, isBatch);
          }
          // this.$nextTick(() => {
          //   this.ExportSavePdf("htmlTitle", "nowPrintDetail");
          // });
          resolve();
        } catch (e) {
          reject();
          console.log(e);
        }
      });
    },
    async batchDownload(arr) {
      console.log(arr, arr.length);
      if (arr.length === 0) {
        this.loading = false;
        return this.$message.warning("请至少选择一项");
      }
      for (let i = 0; i < arr.length; i++) {
        // 当前下载的问题件名
        this.nowTitle = arr[i] && (arr[i].code || arr[i].eventcode);
        console.log(`输出了${i + 1}次`);
        await this.toShowDetails(arr[i], this.activeIndex, true);
      }
      this.loading = false;
      this.isBatchDowlnload = false;
      // arr.forEach(async (item) => await this.toShowDetails(item, "2"));
    },
    // 关闭细节详情对话框
    closeDetailDialog() {
      this.isShowDetailDialog = false;
    },
    toDownload() {
      this.isBatchDowlnload = true;
      this.isShowDownloadDialog = true;
    },
    closeDownloadDialog() {
      this.isShowDownloadDialog = false;
    },
  },
};
</script>

<style lang='less' scoped>
.eventendContainer {
  width: 100%;
  // min-width: 1223px;
  height: 100vh;
  padding: 24px 27px 0;
  box-sizing: border-box;
  .el-card {
    padding: 0 27px;
    min-height: 900px;
    margin-bottom: 36px;
    .navBar {
      width: 100%;
      height: 64px;
      line-height: 64px;
      opacity: 0.66;
      border-bottom: 1px solid #e2e5ec;
      margin-bottom: 30px;
      .el-row,
      .el-col {
        height: 100%;
      }
      .nav {
        height: 100%;
        display: flex;
        justify-content: space-between;
        .navItem {
          display: inline-block;
          width: 64px;
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 400;
          color: #99a9ba;
          cursor: pointer;
        }
      }
      .search {
        height: 64px;
        margin-right: 12px;
      }
    }
    .firstMain,
    .sencondMain,
    .thirdMain,
    .fourthMain,
    .fifthMain {
      width: 100%;
      height: 100%;
      .item {
        margin-bottom: 14px;
        border: 1px solid rgba(226, 229, 236, 0.62);
        padding: 0 10px 0 14px;
        background: #f8fafb;
        .header {
          height: 50px;
          opacity: 0.72;
          border-bottom: 1px solid #e2e5ec;
          margin-bottom: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          i {
            display: inline-block;
            width: 3px;
            height: 14px;
            background: #009157;
            margin-right: 4px;
          }
          .number {
            display: inline-block;
            // width: 300px;
            height: 25px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #2c3a50;
            letter-spacing: 1px;
            margin-right: 10px;
          }
          .result {
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Regular;
          }
        }
        .main {
          opacity: 0.72;
          border-bottom: 1px solid #e2e5ec;
          .main_header {
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #38455a;
            letter-spacing: 1px;
            margin-bottom: 8px;
          }
          .main_item {
            height: 20px;
            line-height: 20px;
            margin-bottom: 8px;
            display: flex;
            .attr {
              width: 110px;
              font-size: 14px;
              font-family: PingFangSC, PingFangSC-Regular;
              color: #969aa5;
              letter-spacing: 1px;
            }
            .desc {
              font-size: 14px;
              font-family: PingFangSC, PingFangSC-Regular;
              color: #38455a;
              letter-spacing: 1px;
            }
          }
          .main_item:last-child {
            margin-bottom: 24px;
          }
        }
      }
    }
  }
  .firstMain {
    .item {
      .status {
        display: inline-block;
        width: 36px;
        height: 22px;
        line-height: 22px;
        border: 1px solid #ff8580;
        border-radius: 2px;
        font-size: 13px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #ff7673;
        letter-spacing: 2px;
        text-align: center;
      }
      .problem {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #ff817e;
        letter-spacing: 1px;
      }
    }
  }
  .sencondMain .desc {
    display: inline-block;
    width: 296px;
    height: 18px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #38455a;
    letter-spacing: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .sencondMain .pic {
    display: inline-block;
    height: 170px;
  }
  .sencondMain .main_item:last-child {
    height: auto !important;
    margin-bottom: 17px !important;
  }
  .promptInfo {
    margin-top: 100px;
    text-align: center;
    font-size: 16px;
    color: #99a9ba;
  }
  .orange {
    color: #ff8582 !important;
  }
  .w60 {
    width: 60px !important;
  }
  .w70 {
    width: 70px !important;
  }
  .w76 {
    width: 76px !important;
  }
  .w80 {
    width: 80px !important;
  }
  .w192 {
    width: 192px !important;
  }
  .h47 {
    height: 47px !important;
  }
  .h193 {
    height: 193px !important;
  }
  .h301 {
    height: 301px !important;
  }
  .h325 {
    height: 325px !important;
  }
  .state {
    color: #009157 !important;
  }
  .state1 {
    color: #ff625e !important;
  }
  .state3 {
    border: 1px solid #009157 !important;
  }
  .check {
    color: #0ac386 !important;
  }
  .active {
    color: #394259 !important;
    font-weight: 600 !important;
    border-bottom: 3px solid var(--themeColor);
  }
  .btn {
    float: right;
  }
}
</style>